// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2_XpQ","productName":"Table_productName__3pY29"};